/* eslint-disable import/no-cycle */
/* eslint-disable class-methods-use-this */
import { BaseModel } from '@/_models/base'
import { cLocation, cOrganization } from './index'

export class Partner extends BaseModel {
  constructor(id = null, username = null, locations = []) {
    super()

    this.id = id
    this.username = username
    this.locations = locations
    this.organization = null
    this.effectiveRole = null

    this.defaultRoute = 'employees'
  }

  static modelName = 'employee'

  static modelNamePlural = 'employees'

  /**
   * @param {Object} json - Partner data from API
   * @returns {Partner} Parsed and sorted partner instance
   */
  fromJSON(json) {
    const item = Object.assign(new Partner(), json)
    item.parseBaseJSON()

    item.locations = (json.locations || [])
      .map(location => cLocation.fromJSON(location))
      .sort((a, b) => a.name.localeCompare(b.name))

    item.organization = json.organization
      ? cOrganization.fromJSON(json.organization)
      : null

    item.effectiveRole = json.effectiveRole ?? null
    return item
  }
}

export const cPartner = new Partner()
